import { RenewalFormTranslations } from '../types';

export const renewalForm: RenewalFormTranslations = {
  // Page Title
  title: "Enrollment Renewal 2026/2027",
  subtitle: "Reserve your child's spot for the next school year. The renewal period is open until March 17th.",

  // Alert Messages
  earlyBirdActive: "🎉 Take advantage of the early booking discount! Reserve before February 23rd and save €50 per child on enrollment.",
  earlyBirdEnded: "The early booking discount period has ended (February 23rd).",

  // Sections
  contactInfo: "Contact Information",
  childrenInfo: "Children to Enroll",
  paymentPreference: "Payment Preference",
  optionalServices: "Additional Services of Interest",
  educationalCommitment: "Educational Commitment",
  pricingSummary: "Cost Summary",

  // Fields
  parentName: "Parent/Guardian Name",
  email: "Email",
  phone: "Phone",
  childName: "Child's Name",
  birthDate: "Date of Birth",
  currentLevel: "Current Level",
  renewalLevel: "Level for 2026/2027",
  isCurrentStudent: "This child is currently enrolled at Gándara",
  isCurrentStudentHelper: "Uncheck this box if this is a new sibling not currently enrolled at the school",
  comments: "Comments or Questions",
  commentsPlaceholder: "Do you have any questions or special circumstances you'd like to share with us?",

  // Levels
  levels: {
    infantil3: "Infant 3 years",
    infantil4: "Infant 4 years",
    infantil5: "Infant 5 years",
    primary1: "Primary - 1st grade",
    primary2: "Primary - 2nd grade",
    primary3: "Primary - 3rd grade",
    primary4: "Primary - 4th grade",
    primary5: "Primary - 5th grade",
    primary6: "Primary - 6th grade",
    // Simplified for 2026-2027
    infantil: "Infant (3 to 6 years)",
    primary: "Primary C1 (6 to 8 years)",
    primaryC2: "Primary C2 (9 to 11 years)"
  },

  // Payment
  paymentMonthly: "Monthly Payment (10 payments)",
  paymentAnnual: "Annual Payment (1 payment)",
  annualSavings: "Save €200 per child with annual payment",

  // Services
  transport: "Transportation",
  transportPricing: "€225/month round trip (minimum 4 places)",
  comedor: "Lunch",
  comedorPricing: "€195/month 5 days · €125 3 days · €90 2 days · €15 single day",
  aulaMadruga: "Early Birds",
  aulaMadrugaPricing: "€75/month per family (from 8:15 AM)",
  servicesNote: "Prices shown are for reference. Additional services enrollment is handled separately.",

  // Commitment
  commitmentTitle: "Educational Commitment 2026/2027",
  commitmentText: `The undersigned parties declare that the family-school relationship will be governed by a spirit of mutual collaboration and trust to jointly contribute to the education and training of children. To this end, they acknowledge that:

1. Gándara International School (GIS) is a foreign educational center, authorized by the Xunta de Galicia and accredited as an international school by NEASC (New England Association of Schools and Colleges) for Early Childhood Education and Primary Education. It offers private education at its Gondomar center, located at Lugar de Moureira, number 1, parish of Mañufe, based on active and experiential pedagogy.

2. The duration of this commitment covers the 2026/2027 school year, starting on September 1, 2026. This duration may be renewed annually when the enrollment reservation process opens, provided there is express written consent from the child's parents and the Center itself.

3. The center's program and curriculum will be governed by the School Calendar of the Autonomous Community of Galicia.

4. The Center will be governed by the Standards of the Coexistence Plan, Child Protection Plan, Internal Rules of Conduct, and other internal policies of the center.

5. Families must provide truthful and complete information about their child during the admission process, especially regarding health aspects, allergies, intolerances, and any information that may be relevant for the proper development of the minor.

6. As the center does not have a multidisciplinary team for students with special educational needs, if such needs arise, parents/guardians commit to providing external evaluation with appropriate specialists and/or specific support through external therapies. Likewise, diagnoses, treatments, and reports issued by external therapists must be transferred to the center to work in collaboration with these offices and achieve favorable progress. The center reserves the right to disagree with the pedagogical approach followed by the office chosen by the parents/guardians.

7. In case of non-compliance with this commitment as well as other standards published on the center's website and available to all parents/guardians, it may be terminated by the Center, with the possibility of non-renewal of enrollment for the following year and/or adoption of measures expressly stated in each case.`,
  commitmentAccept: "I have read and accept the Educational Commitment for the 2026/2027 school year",

  // Privacy
  privacyAccept: "I have read the data protection information",

  // Pricing Summary
  summaryTitle: "Your Cost Summary",
  summaryMatricula: "Enrollment",
  summaryMonthly: "Monthly",
  summaryAnnual: "Annual",
  summaryEarlyBird: "Early bird discount",
  summaryAnnualDiscount: "Annual payment discount",
  summaryTotal: "Annual Total (10 months)",
  summaryGrandTotal: "TOTAL TO PAY",
  summaryNote: "Additional services are not included in the total",
  summaryPerMonth: "x 10 months",
  summaryPerYear: "year",
  // Payment timing clarity
  summaryPayNow: "To Pay Now (bank transfer)",
  summaryBankTransferNote: "Make the transfer in August before the start of the school year",
  summaryPayDuringYear: "Payments During the School Year",
  summaryMonthlyPayments: "Monthly payments (Sept-June)",
  summaryMonthlyBreakdown: "10 monthly payments from September to June",
  summaryPayAnnual: "Annual Payment (September)",
  summaryAnnualBase: "Annual total",
  summaryAnnualTotal: "Total with discount",
  summaryAnnualNote: "Single payment in September",
  siblingLabels: {
    first: "1st sibling",
    second: "2nd sibling",
    third: "3rd+ sibling"
  },

  // Buttons
  addChild: "Add Another Child",
  removeChild: "Remove",
  submit: "Confirm Renewal",
  submitting: "Sending...",

  // Messages
  success: "Renewal confirmed! Redirecting to confirmation page...",
  error: "Error submitting renewal. Please try again or contact us.",
  suggestedLevel: "Based on date of birth, we suggest level:",
  allChildrenNewWarning: "You've marked all children as new students. Is this correct? New students have different pricing than renewal pricing.",

  // Validation
  required: "This field is required",
  invalidEmail: "Email is not valid",
  invalidPhone: "Phone must be at least 9 digits",
  invalidDate: "Date is not valid",
  futureDateError: "Date of birth cannot be in the future",
  oldDateWarning: "This date suggests an age of {age} years. Please confirm this is correct.",
  atLeastOneChild: "You must add at least one child"
};
